var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "120px",
    viewBox: "0 0 145 120",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.889 26.4449L137.94 43.8428L112.812 44.0446L104.626 44.1107L85.1995 44.2673L77.017 44.3334L57.5907 44.49L49.4082 44.5561L29.9819 44.7162L21.7993 44.7823L8.68638 44.8867L6.14996 39.6882L2.85955 32.9552L1.04237 29.2285L0 26.4449L6.23683 6.6634C7.48812 2.69701 11.1622 0.000453173 15.3158 0L128.788 0C132.815 0.00221943 136.405 2.54048 137.756 6.3398L138.478 8.37883L144.889 26.4449Z",
    transform: "translate(0 20.70355)",
    id: "Path",
    fill: "#FFBF4D",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L144.889 0L144.889 36.5358L0 36.5358L0 0Z",
    transform: "translate(0 47.1488)",
    id: "Rectangle",
    fill: "#E67F45",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L144.889 0L144.889 36.5358L0 36.5358L0 0Z",
    transform: "translate(0 47.1488)",
    id: "Rectangle",
    fill: "#000000",
    fillOpacity: 0.1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L92.7706 0L92.7706 116.914L0 116.914L0 0Z",
    transform: "translate(25.88544 0)",
    id: "Rectangle",
    fill: "#F3DAB9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L27.1015 0L27.1015 3.82755L0 3.82755L0 0Z",
    transform: "translate(45.3429 8.351013)",
    id: "Rectangle",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L81.652 0L81.652 1.73979L0 1.73979L0 0ZM0 5.56735L81.652 5.56735L81.652 7.30715L0 7.30715L0 5.56735ZM0 11.1347L81.652 11.1347L81.652 12.8745L0 12.8745L0 11.1347ZM0 16.702L81.652 16.702L81.652 18.4418L0 18.4418L0 16.702ZM0.250671 22.9908L81.9027 22.9908L81.9027 24.7306L0.250671 24.7306L0.250671 22.9908ZM0 27.8367L81.652 27.8367L81.652 29.5765L0 29.5765L0 27.8367Z",
    transform: "translate(31.09723 24.00916)",
    id: "Combined-Shape",
    fill: "#EEBE96",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.91529C0 9.18222 2.64454 11.8306 5.90674 11.8306C9.16743 11.8269 11.8098 9.18071 11.8135 5.91529C11.8135 2.64837 9.16894 0 5.90674 0C2.64454 0 0 2.64837 0 5.91529ZM1.09163 3.91792C1.89832 1.96757 3.79875 0.695907 5.90674 0.695907C8.7838 0.699165 11.1153 3.03405 11.1186 5.91529C11.1186 8.02633 9.84875 9.92951 7.90122 10.7374C5.95369 11.5452 3.71199 11.0987 2.22142 9.60595C0.730842 8.11322 0.284939 5.86827 1.09163 3.91792Z",
    transform: "translate(28.6651 3.479614)",
    id: "Shape",
    fill: "#E67F45",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.7233L0 0L18.7626 14.6143L126.821 13.9182L144.889 0L144.889 72.7233L0 72.7233Z",
    transform: "translate(0 47.14853)",
    id: "Path",
    fill: "#E67F45",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6abefa10dc605475addde8ad2f55dfab.svg";
export { ForwardRef as ReactComponent };